import { readCreditBundles } from '@api/user';
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { ErrorText, TableData } from '@utilities';
import { ITEM_COLUMNS } from '@api/user/utilities/helpers';
import styles from './_index.module.scss';

const CreditBundles = () => {
  const { surveyInfo } = useSelector((state) => state?.user?.data);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [tableData, setTableData] = useState({ columns: ITEM_COLUMNS, data: [] });

  useEffect(() => {
    const fetchCreditBundles = async () => {
      try {
        const { data } = await readCreditBundles();

        if (!data?.columns?.length || !data?.data) {
          throw new Error('No columns or data available');
        }

        setTableData({
          columns: data.columns,
          data: data.data,
        });
      } catch (error) {
        console.error('error', error);
        setError(error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchCreditBundles();
  }, []);

  if (error) {
    return <ErrorText role="alert" text={error?.message} />;
  }

  return (
    <>
      <TableData columns={tableData.columns} data={tableData.data} isLoading={isLoading} />
      {surveyInfo?.clientCreditBundleLastUpdated && (
        <div className={styles['credit-bundles-last-updated']}>
          * Last updated on {surveyInfo?.clientCreditBundleLastUpdated}
        </div>
      )}
    </>
  );
};

export default CreditBundles;
